export const NEW_HOME_WALKTHROUGH_ID = "new-home";

/** Set on the page once its sections have loaded. */
export const NEW_HOME_READY_SELECTOR = `[data-walkthrough-ready="${NEW_HOME_WALKTHROUGH_ID}"]`;

export const PLG_REVENUE_HERO_SELECTOR = '[data-testid="plg-revenue-hero"]';
export const PLG_VALUE_BREAKDOWN_OPEN_SELECTOR =
  '[data-testid="plg-value-breakdown-open"]';
/** Matches whichever Commerce Agent promo the team is shown. */
export const PLG_PROMO_SELECTOR =
  '[data-testid^="plg-promo-card-commerce-agent"]';
/** The promo once Commerce Agent is on, in place of its pitch. */
export const PLG_PROMO_LATEST_SELECTOR =
  '[data-testid="plg-promo-card-commerce-agent-latest"]';
export const PLG_WINS_SELECTOR = '[data-testid="plg-wins"]';
export const PLG_WIN_TEST_ID_PREFIX = "plg-win-";
/** The win cards in the row; cards carry `plg-win-<ref>`, values `-value`. */
export const PLG_WIN_CARD_SELECTOR = `${PLG_WINS_SELECTOR} [data-testid^="${PLG_WIN_TEST_ID_PREFIX}"]:not([data-testid$="-value"])`;
export const PLG_CUSTOMIZE_WINS_SELECTOR =
  '[data-testid="plg-customize-wins-button"]';
export const PLG_PRODUCTS_SETUP_SELECTOR = '[data-testid="plg-products-setup"]';
/** The products section swaps its test id for its setup and empty states. */
export const PLG_PRODUCTS_SELECTOR =
  '[data-testid="plg-products"], [data-testid="plg-products-setup"], [data-testid="plg-products-empty"]';
/** The first opportunity card; cards carry `plg-opportunity-<id>`. */
export const PLG_FIRST_OPPORTUNITY_SELECTOR =
  '[data-testid="plg-opportunities"] [data-testid^="plg-opportunity-"]';
export const PLG_OPPORTUNITIES_TITLE_SELECTOR =
  '[data-testid="plg-opportunities"] h2';
export const HOME_NAV_SELECTOR = '[data-testid="primary-nav-home"]';
